import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { EnrolledGroupItem } from "../types";

interface UseEnrolledGroupsListArgs {
  corporateId: string | number;
  objectId: number;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export const useEnrolledGroupsList = ({
  corporateId,
  objectId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseEnrolledGroupsListArgs): PaginatedListResult<EnrolledGroupItem> => {
  const url = corporateId
    ? `${ServicesURL.getGroupsEnrolledWithEnrollInfo}?corporateId=${corporateId}&objectId=${objectId}`
    : null;

  return usePaginatedList<EnrolledGroupItem>(
    url,
    {
      page,
      pageSize,
      search,
      fieldFilters,
    },
    {
      responseKey: "response",
      totalElementsKey: "total_elements",
      totalPagesKey: "total_pages",
    },
  );
};
